/**
 * Slider Component
 *
 * @file slider.js
 */

import $ from "jquery";
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Autoplay, EffectCoverflow, EffectFade, Controller, Thumbs  } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Autoplay, EffectCoverflow, EffectFade, Controller, Thumbs ]);

import 'swiper/swiper-bundle.css';
import 'swiper/swiper-bundle.min.js';
import 'swiper/components/effect-coverflow/effect-coverflow.min.css';
import 'swiper/components/effect-fade/effect-fade.min.css';

const slider = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const fullSlider = () => {
    let mainSlider = new Swiper('.main-slider', {
      navigation: {
        nextEl: ".hm-next",
        prevEl: ".hm-prev ",
      },
      autoplay: {
        delay: 6000,
      },
      slidesPerView: 1,
      pagination: false,
      speed:1200,
      noSwiping:true,
      allowTouchMove:false,
      watchSlidesProgress: true,
      loop:true,
      effect: "fade",
      breakpoints: {
        0: {
          noSwiping:false,
          allowTouchMove:true,
          calculateHeight:true,
          autoHeight:true,
        },
        680: {
          noSwiping:false,
          allowTouchMove:true,
          calculateHeight:true,
          autoHeight:true,
        },
        992: {
          noSwiping:true,
          allowTouchMove:false,
        },
        1000: {
          calculateHeight:false,
          autoHeight:false,
        },
      }
    });
  };

  const homeServicesSlider = () => {
    const homeServicesSlider = new Swiper('.home-services-carousel', {
      slidesPerView: 6,
      spaceBetween: 20,
      watchSlidesProgress: true,
      speed:700,
      navigation: {
        nextEl: ".sc-next",
        prevEl: ".sc-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 2,
          allowTouchMove: true,
        },
        680: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 3,
        },
        1000: {
          slidesPerView: 3,
        },
        1100: {
          slidesPerView: 5,
        },
        1300: {
          slidesPerView: 6,
        },
        1520: {
          slidesPerView: 6,
        },
      }
    });
  }

  const homeAboutCarousel = () => {
    const homeAboutCarousel = new Swiper('.home-about-carousel', {
      slidesPerView: 1,
      spaceBetween: 0,
      watchSlidesProgress: true,
      autoHeight:true,
      navigation: {
        nextEl: ".hm-ab-next",
        prevEl: ".hm-ab-prev",
      },
    });
  }

  const homeNewsCarousel = () => {
    const homeNewsCarousel = new Swiper('.home-news-carousel', {
        slidesPerView: 2,
        spaceBetween: 15,
        loop:true,
        navigation: {
          nextEl: ".hm-nw-next",
          prevEl: ".hm-nw-prev ",
        },
        breakpoints: {
          0: {
            spaceBetween: 0,
            slidesPerView: 1,
            allowTouchMove: true,
          },
          680: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
        }
    });
  };

  const homeWorkCarousel = () => {
    const homeNewsCarousel = new Swiper('.home-work-carousel', {
        slidesPerView: 6,
        spaceBetween: 20,
        loop:true,
        navigation: {
          nextEl: ".hm-wk-next",
          prevEl: ".hm-wk-prev ",
        },
        breakpoints: {
          0: {
            slidesPerView: 2,
            allowTouchMove: true,
          },
          680: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: 3,
          },
          1000: {
            slidesPerView: 3,
          },
          1100: {
            slidesPerView: 4,
          },
          1300: {
            slidesPerView: 5,
          },
          1520: {
            slidesPerView: 6,
          },
        }
    });
  };

  const init = () => {
    fullSlider();
    homeServicesSlider();
    homeAboutCarousel();
    homeNewsCarousel();
    homeWorkCarousel();
  };

  return {
    init,
  };
})();

export default slider;
